"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    palette: palette,
    display: 'flex',
    progressBackground: palette.elDivider,
    progressColor: palette.elAccent,
    color: palette.tInactive,
    fontSize: palette.tsNormal,
    lineHeight: 1.5,
    width: '100%',
    minWidth: 'auto'
  };
}